import * as __knightedLocals from "!!/home/runner/work/css-jsx-app/css-jsx-app/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[0].use[1]!/home/runner/work/css-jsx-app/css-jsx-app/src/components/shared_bridge_panel.module.css?knighted-css";
import * as __knightedUpstream from "!!/home/runner/work/css-jsx-app/css-jsx-app/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[0].use[1]!/home/runner/work/css-jsx-app/css-jsx-app/src/components/shared_bridge_panel.module.css?knighted-css";
const __knightedDefault =
  Object.prototype.hasOwnProperty.call(__knightedUpstream, 'default')
    ? __knightedUpstream['default']
    : __knightedUpstream;
const __knightedResolveCss = function resolveCssText(primary, module) {
    const candidates = [primary, module, module?.default];
    for (const candidate of candidates) {
        if (typeof candidate === 'string') {
            return candidate;
        }
        if (candidate &&
            typeof candidate.toString === 'function') {
            const text = String(candidate.toString());
            if (text && text !== '[object Object]' && text !== '[object Module]') {
                return text;
            }
        }
    }
    return '';
};
const __knightedResolveCssModules = function resolveCssModules(primary, module) {
    const candidates = [primary, module, module?.default];
    for (const candidate of candidates) {
        if (!candidate || typeof candidate !== 'object')
            continue;
        if (!('locals' in candidate))
            continue;
        const locals = candidate.locals;
        if (!locals || typeof locals !== 'object')
            continue;
        return locals;
    }
    const normalizeStringMapLocal = (value) => {
        const entries = Object.entries(value).filter(([key]) => key !== 'default' && key !== '__esModule');
        if (entries.length === 0)
            return undefined;
        if (!entries.every(([, entry]) => typeof entry === 'string'))
            return undefined;
        return Object.fromEntries(entries);
    };
    for (const candidate of candidates) {
        if (!candidate || typeof candidate !== 'object')
            continue;
        const normalized = normalizeStringMapLocal(candidate);
        if (normalized)
            return normalized;
    }
    const collectNamedExportsLocal = (value) => {
        if (!value || typeof value !== 'object')
            return undefined;
        const output = {};
        for (const [key, entry] of Object.entries(value)) {
            if (key === 'default' || key === '__esModule')
                continue;
            if (typeof entry === 'string') {
                output[key] = entry;
            }
        }
        return Object.keys(output).length > 0 ? output : undefined;
    };
    return collectNamedExportsLocal(module);
};
const __knightedUpstreamLocals =
  __knightedResolveCssModules(__knightedUpstream, __knightedUpstream);
const __knightedLocalsExport =
  __knightedUpstreamLocals ??
  __knightedResolveCssModules(__knightedLocals, __knightedLocals);
const __knightedBaseCss = __knightedResolveCss(__knightedDefault, __knightedUpstream);
const __knightedCss = [__knightedBaseCss, ].filter(Boolean).join('\n');
export const knightedCss = __knightedCss;
const __knightedCssModules = Object.assign({}, ...[__knightedLocalsExport ?? __knightedResolveCssModules(
  __knightedDefault,
  __knightedUpstream,
), ].filter(Boolean));
export const knightedCssModules = __knightedCssModules;
export default __knightedCss;